import { useEffect, useState } from 'react';

import type { FileWithDataURL } from '#src/components/form/UploadFile/useUploadFile.ts';

import type { ImageQualityIssue } from './analyzeImageQuality.ts';
import { analyzeImageQuality } from './analyzeImageQuality.ts';

export const useImageQualityWarnings = (file: FileWithDataURL | undefined) => {
  const [issues, setIssues] = useState<ImageQualityIssue[]>([]);

  useEffect(() => {
    let cancelled = false;

    const analysis = file
      ? analyzeImageQuality(file.file)
      : Promise.resolve([]);
    analysis.then(result => {
      if (!cancelled) setIssues(result);
    });

    return () => {
      cancelled = true;
    };
  }, [file]);

  return issues;
};
